module.exports = __webpack_public_path__ + "img/Blog web 2.de8566ce.png";